export default __webpack_public_path__ + "static/media/icn_refresh_spin.fd44f96d.svg";